import IPlatformConfig from '../model/IPlatformConfig';
import getJsonnetData from '../../../../common/utilities/getJsonnetData';
import CONSTANTS from '../constants/constants';
import priceDisplayConfigTransformer from '../service/priceDisplayConfigTransformer';
import IDimensions from '../model/IDimensions';

const { APP_CONFIG_BASE_URL } = CONSTANTS;

const jsonnetApi = {
  getConfiguration: async ({ brand, region, country, language }: IDimensions): Promise<void | IPlatformConfig> => {
    try {
      const response = await (await getJsonnetData(APP_CONFIG_BASE_URL, brand, region, country, language)).json();
      const { platformFeatures } = response;

      if (!platformFeatures) {
        throw new Error(`Missing feature flags platform configuration.`);
      }

      return {
        isVariantsPageEnabled: platformFeatures.variantsPage === true,
        isFuelFilteringEnabled: platformFeatures.fuelFilter === true,
        isBodyStyleFilteringEnabled: platformFeatures.bodyStyleFilter === true,
        isTransmissionFilteringEnabled: platformFeatures.transmissionFilter === true,
        isPriceSortingEnabled: platformFeatures.carPriceSorting === true,
        isDealerSelectionEnabled: platformFeatures.dealerSelectionIntegration === true,
        isSaveOfferEnabled: platformFeatures.saveOffer === true,
        isFinanceEnabled: platformFeatures.financeIntegration === true,
        isCheckoutLiteEnabled: platformFeatures.spcCheckoutLiteIntegration === true,
        showGovernmentCharges: platformFeatures.showGovernmentCharges === true,
        hideSubmitWhenNoStock: platformFeatures.hideSubmitWhenNoStock === true,
        isComplexModel: platformFeatures.complexModel === true,
        gqlApi: platformFeatures.gqlApi === true,
        stockPage: platformFeatures.stock,
        priceDisplay: priceDisplayConfigTransformer.fromJsonnet(response?.priceDisplay),
        isCheckout3Enabled: platformFeatures.isCheckout3Enabled === true,
        isCheckout4Enabled: platformFeatures.isCheckout4Enabled === true,
        isStockLiteEnabled: platformFeatures.isStockLiteEnabled,
        dxpDataLayer: platformFeatures.dxpDataLayer === true,
      };
    } catch (e) {
      throw new Error(`Unable to get platform configuration.`);
    }
  },
};

export default jsonnetApi;
